import type { Run } from "./types";
import { request } from "./api";

export interface RunSummaryFilters {
  page: number;
  pageSize: number;
  status?: string;
  runType?: string;
  q?: string;
}
export interface RunSummaryPage {
  total: number;
  offset: number;
  limit: number;
  items: Run[];
}
interface SummaryRecord extends Run {
  dataset_version_id: string;
  summary: Run["summary"] & { scope: "task_execution"; cancelled: number; statuses: Record<string, number> };
}

export async function readRunSummaries(filters: RunSummaryFilters, signal?: AbortSignal): Promise<RunSummaryPage> {
  const params = new URLSearchParams({
    limit: String(filters.pageSize),
    offset: String((filters.page - 1) * filters.pageSize),
  });
  if (filters.status && filters.status !== "all") params.set("status", filters.status);
  if (filters.runType && filters.runType !== "all") params.set("run_type",filters.runType);
  if (filters.q) params.set("q", filters.q);
  const page = await request<Omit<RunSummaryPage, "items"> & { items: SummaryRecord[] }>(
    `/api/v1/platform/run-summaries?${params}`, { signal },
  );
  return { ...page, items: page.items.map((item) => ({
    ...item, config: { ...item.config, dataset_id: item.dataset_version_id },
  })) };
}
